import React from "react";
import styled from "styled-components";
import { Layout } from "../components/layout/Layout";

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: var(--spacing-4);
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: var(--spacing-6);
  color: var(--color-text-primary);
`;

const Section = styled.section`
  margin-bottom: var(--spacing-6);
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-3);
`;

const Content = styled.div`
  color: var(--color-text-secondary);
  line-height: 1.6;

  p {
    margin-bottom: var(--spacing-3);
  }

  ul {
    margin-bottom: var(--spacing-3);
    padding-left: var(--spacing-4);
  }

  li {
    margin-bottom: var(--spacing-2);
  }
`;

const CookiePolicy = () => {
  return (
    <Layout>
      <Container>
        <Title>Politique des Cookies</Title>

        <Section>
          <SectionTitle>1. Définition</SectionTitle>
          <Content>
            <p>
              Les cookies sont de petits fichiers texte stockés sur votre
              appareil lors de votre navigation sur notre site.
            </p>
          </Content>
        </Section>

        <Section>
          <SectionTitle>2. Types de Cookies Utilisés</SectionTitle>
          <Content>
            <ul>
              <li>Cookies essentiels (nécessaires au fonctionnement)</li>
              <li>Cookies de performance (analyse du trafic)</li>
              <li>Cookies de personnalisation</li>
              <li>Cookies publicitaires</li>
            </ul>
          </Content>
        </Section>

        <Section>
          <SectionTitle>3. Finalités</SectionTitle>
          <Content>
            <p>Nous utilisons les cookies pour :</p>
            <ul>
              <li>Améliorer la navigation</li>
              <li>Mémoriser vos préférences</li>
              <li>Analyser l'utilisation du site</li>
              <li>Personnaliser votre expérience</li>
            </ul>
          </Content>
        </Section>

        <Section>
          <SectionTitle>4. Contrôle des Cookies</SectionTitle>
          <Content>
            <p>
              Vous pouvez contrôler et/ou supprimer les cookies comme vous le
              souhaitez. Vous pouvez supprimer tous les cookies déjà présents
              sur votre appareil et paramétrer la plupart des navigateurs pour
              qu'ils les bloquent.
            </p>
          </Content>
        </Section>

        <Section>
          <SectionTitle>5. Plus d'Informations</SectionTitle>
          <Content>
            <p>
              Pour toute question concernant notre utilisation des cookies :
              <br />
              Email : ytbrelaxmusic@gmail.com
            </p>
          </Content>
        </Section>
      </Container>
    </Layout>
  );
};

export default CookiePolicy;
